import { render, staticRenderFns } from "./CriarExercicio.vue?vue&type=template&id=6779ed74&scoped=true"
import script from "./CriarExercicio.vue?vue&type=script&lang=js"
export * from "./CriarExercicio.vue?vue&type=script&lang=js"
import style0 from "./CriarExercicio.vue?vue&type=style&index=0&id=6779ed74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6779ed74",
  null
  
)

export default component.exports